module.exports = __webpack_public_path__ + "img/CToday.da7f963b.jpg";